// src/components/store/sections/blog-posts/BlogV11TicketpressLimeZest.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV11TicketpressLimeZest(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={11}
      archKey="ticket_press"
      archLabel="Press Pass Stub Cards"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
